import { useCallback, useState } from 'react';

import useService from './useService';

const useKycBankNameMismatch = () => {
	const { getBankNameMismatchRejections, canApprove } = useService();
	const [forceUpdate, setForceUpdate] = useState<boolean>(false);
	const [lookbackDays, setLookbackDays] = useState<number>(0);

	/**
	 * Passed straight to DataList. At most one row comes back (the newest attempt in the window), so
	 * paging arguments are ignored.
	 */
	const fetchData = useCallback(async () => {
		const result = await getBankNameMismatchRejections();
		// Kept so the empty state can name the window the backend actually applied.
		setLookbackDays(result.lookbackDays);
		return result;
	}, [getBankNameMismatchRejections]);

	const turnGlobalForceUpdateOff = useCallback(() => setForceUpdate(false), []);

	/** Re-runs the query. Used after an approval so the row shows as approved and its siblings drop off. */
	const refresh = useCallback(() => setForceUpdate(true), []);

	return { fetchData, forceUpdate, turnGlobalForceUpdateOff, refresh, canApprove, lookbackDays };
};

export default useKycBankNameMismatch;
